// extracted by mini-css-extract-plugin
module.exports = {"header__image":"page-module--header__image--5QocD","header__title":"page-module--header__title--dt-iz","content":"page-module--content--NsxoX"};